import React from "react";
import HeaderSection from "../../../components/headerSection";
import HowWorks from "../../../components/howItWorks";
import ImageTextCard from "../../../components/imageTextCard";
import Footer from "../home/footer";
import BecomeMentor from "./becomeMentor";
import ConnectMentor from "./ourmentor";
import TeamSection from "./teammember";
function AiCareerMentors() {
  const obj = [
    {
      id: "01",
      icon: "/build-profile.png",
      heading: "Complete Assessment",
      content: "Complete your Assessments and obtain results",
    },
    {
      id: "02",
      icon: "/goal-achievement.png",
      heading: "Mentor Match or Seach",
      content:
        "Search and Connect with a Mentor to discuss results and receive guidance",
    },
    {
      id: "03",
      icon: "/goal-achievement.png",
      heading: "Connect with Mentor",
      content: " Meet with mentor via a zoom meeting ",
    },
  ];

  return (
    <div>
      <HeaderSection
        title="AI Career Mentors"
        description="Unlock Your Career Growth with Guidance from Expert AI Mentors"
      />
      <TeamSection />
      <ImageTextCard
        image="/background2.png"
        imageClass="w-[640px] h-auto"
        label=" Integrate your AI Job Assessment with Personalised Guidance"
        subTitle="Navigating career transitions can be challenging, but you don't have
            to do it alone. Our AI Career Mentors program connects you with
            experienced professionals who offer personalized advice, industry
            insights, and support tailored to your goals. By integrating with
            our AI Job Assessment tool, we ensure that the guidance you receive
            is perfectly aligned with your unique assessment results and career
            aspirations."
      />
      <HowWorks obj={obj} />
      <ConnectMentor />
      <BecomeMentor />
      <Footer />
    </div>
  );
}

export default AiCareerMentors;
